import { useMediaQuery } from "@chakra-ui/react";

// A wide phone in landscape is still a phone. Requiring desktop-like height keeps
// the full header, right-hand map list, and profile overlay off shallow screens.
export const DESKTOP_LAYOUT_QUERY = "(min-width: 48em) and (min-height: 37.5em)";
const COMPACT_HEIGHT_QUERY = "(max-height: 35em)";
const PHONE_LANDSCAPE_QUERY = "(max-height: 35em) and (orientation: landscape)";
const NARROW_PHONE_QUERY = "(max-width: 23.5em)";

export default function useResponsiveLayout() {
  const [isDesktopLayout, isCompactHeight, isPhoneLandscape, isNarrowPhone] = useMediaQuery(
    [
      DESKTOP_LAYOUT_QUERY,
      COMPACT_HEIGHT_QUERY,
      PHONE_LANDSCAPE_QUERY,
      NARROW_PHONE_QUERY,
    ],
    { ssr: false },
  );

  return {
    isDesktopLayout,
    isCompactHeight: !isDesktopLayout && isCompactHeight,
    isPhoneLandscape: !isDesktopLayout && isPhoneLandscape,
    isNarrowPhone: !isDesktopLayout && isNarrowPhone,
  };
}
